var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"app":""}},[_c('div',{staticClass:"pb-12",attrs:{"id":"main"}},[_c('NavBar'),_c('v-main',[_c('router-view')],1)],1),_c('v-footer',{attrs:{"absolute":!_vm.fixed,"app":""}},[_c('v-spacer'),_c('span',[_vm._v("Legacy Flooring - Bend, Oregon | © "+_vm._s(new Date().getFullYear()))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }